<div class="add-depenses-dettes" *ngIf="propertyId">
  <div class="encadre-icon">
    <img
      class="info-icon"
      src="{{ 'assets/images/information-circle.svg' | cheminAbsoluStatique }}"
      alt="Information"
    />
  </div>
  <p class="depenses-dettes-text">
    {{ 'propriete.detail.ajouter-depenses-dettes-1' | translate }}
    <button *ngIf="!hasDepenses" class="text-only-button" id="edit-depenses" (click)="editDepenses()">
      {{ 'propriete.detail.depenses' | translate }}
    </button>
    <ng-container *ngIf="!hasDepenses && !hasDettes">{{ 'propriete.detail.et' | translate }}</ng-container>
    <button *ngIf="!hasDettes" class="text-only-button" id="edit-dettes" (click)="editDettes()">
      {{ 'propriete.detail.dettes' | translate }}
    </button>
    {{ 'propriete.detail.ajouter-depenses-dettes-2' | translate }}
  </p>
</div>
